import { Avatar } from 'antd';
import { useEffect, useRef, useState } from 'react';
import SvgIcon from '../components/SvgIcon';
import { ReactComponent as SettingIcon } from '../assets/icons/menu-icon/setting.svg';
import { ReactComponent as LogoutIcon } from '../assets/icons/menu-icon/logout.svg';
import { LOGIN } from '../utils/constants/itemScreen';
import { useNavigate } from 'react-router-dom';
import { HTTP_ERROR_MESSAGE, UNKNOWN_ERROR } from '../utils/constants/strings';
import { OpenToast } from '../utils/helpers/function';
import { NOTIFY_TYPE } from '../utils/constants/enums';
import { ROUTES } from '../utils/constants/routes';
import { useGlobalStore } from '../stores/globalState';
import { useAuthStore } from '../stores/authStore';
import AuthService from '../pages/auth/services/authServices';
import { useChangePassword } from '../pages/auth/hook/useChangePassword';
import ChangePassword from '../pages/auth/component/ChangePassword';
import ModalShowData from '../components/modal/ModalShowData';
import ModalConfirm from '../components/modal/ModalConfirm';
const Header = () => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const { collapsed, setIsLoading } = useGlobalStore();
  const { form, fieldsChangePassword, modalChangePassword, modalConfirm, setModalChangePassword, handleChangePassword, handleCancelForm } =
    useChangePassword();
  const [isDrop, setIsDrop] = useState(false);
  const { logout } = useAuthStore();
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');

  /**
   * Open dropdown logout
   */
  const openDropLogout = () => {
    setIsDrop(true);
  };

  /**
   * Handle click logout
   * @returns
   */
  const handleClickLogout = async () => {
    try {
      setIsLoading(true);
      const response = await AuthService.logout();

      if (response && response.isError) {
        const errorMessage = response?.message || HTTP_ERROR_MESSAGE[500];
        OpenToast({ message: errorMessage }, NOTIFY_TYPE.ERROR);
        return;
      }
      // Clear user information in local storage and cookies
      logout();
      // Redirect to login page
      navigate(ROUTES.LOGIN, { replace: true });
    } catch (e: unknown) {
      if (e instanceof Error) {
        OpenToast({ message: e.message }, NOTIFY_TYPE.ERROR);
      } else {
        console.error(UNKNOWN_ERROR, e);
      }
    } finally {
      // setIsDrop(false);
      setIsLoading(false);
    }
  };

  /**
   * Use effect to handle click outside dropdown
   */
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsDrop(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  // Get user information from local storage
  useEffect(() => {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo && userInfo !== null && userInfo !== undefined) {
      const user = JSON.parse(userInfo);
      // Get the first 2 characters of the user
      setUserName(user?.username?.substring(0, 2).toUpperCase());
    }

    return () => {
      setUserName('');
    };
  }, []);

  return (
    <div
      className="sys-layout__header"
      style={{
        width: collapsed ? 'calc(100% - 80px)' : 'calc(100% - 254px)',
      }}
    >
      <Avatar className="sys-layout__header-avatar" size="large" gap={4} onClick={openDropLogout}>
        {userName || 'US'}
      </Avatar>

      {/* Dropdown content list setting and logout */}
      {isDrop && (
        <div ref={wrapperRef} className="sys-layout__header-dropdown">
          <div
            className="sys-layout__header-dropdown-item"
            onClick={() => {
              setIsDrop(false);
              setModalChangePassword({
                isOpen: true,
                content: (
                  <ChangePassword
                    fieldsChangePassword={fieldsChangePassword}
                    form={form}
                    onFinish={handleChangePassword}
                    onFinishFailed={() => {}}
                  />
                ),
              });
            }}
          >
            <span className="sys-layout__header-dropdown-icon">
              <SvgIcon svg={SettingIcon} width={32} height={32} />
            </span>
            {LOGIN.SETTING}
          </div>
          <div
            className="sys-layout__header-dropdown-item"
            onClick={() => {
              handleClickLogout();
            }}
          >
            <span className="sys-layout__header-dropdown-icon">
              <SvgIcon svg={LogoutIcon} width={32} height={32} />
            </span>
            {LOGIN.LOGOUT}
          </div>
        </div>
      )}
      <ModalShowData
        isOpen={modalChangePassword.isOpen}
        width={360}
        content={modalChangePassword.content}
        handleRightButton={() => form.submit()}
        handleLeftButton={() => handleCancelForm()}
      />

      {/* Modal confirm change pass success */}
      <ModalConfirm
        isOpen={modalConfirm.isOpen}
        title={modalConfirm.title}
        handleRightButton={() => {
          logout();
          // Redirect to login page
          navigate(ROUTES.LOGIN, { replace: true });
        }}
      />
    </div>
  );
};

export default Header;
